import type { CredentialGuide } from '../api/types'
import { t } from '../i18n/lingua'

/**
 * «Come preparo … per CENSO?» per un tipo di credenziale: l’accesso dedicato
 * e in sola lettura da creare sul sistema, i permessi che bastano, da dove deve
 * arrivare la sonda. Il testo viene dal catalogo delle credenziali
 * (`credential_guides` nel Control Plane), lo stesso aspetto delle guide
 * scritte a mano (AWS, FortiGate, Hyper-V, Wazuh), chiusa di default.
 * I comandi si mostrano così come sono, senza traduzione.
 */
export function GuidaCredenziale({ guida }: { guida: CredentialGuide }) {
  return (
    <details className="guida-chiave">
      <summary>{t(guida.title)}</summary>
      <div className="guida-chiave__corpo">
        <p>{t(guida.intro)}</p>
        {guida.sections.map((s) => (
          <div key={s.title}>
            <h4>{t(s.title)}</h4>
            {s.steps.length > 0 && (
              <ol>
                {s.steps.map((passo) => <li key={passo}>{t(passo)}</li>)}
              </ol>
            )}
            {s.code.length > 0 && (
              <pre>
                <code>{s.code.join('\n')}</code>
              </pre>
            )}
          </div>
        ))}
      </div>
    </details>
  )
}
